/* globals window */

export const withStopPropagation = (func: (event: any) => void) => (
  event?: any,
) => {
  event.stopPropagation();
  func(event);
};

export function fitText(el: any): undefined | string {
  if (!el) {
    return;
  }
  // max font size in pixels
  const width = el.clientWidth;
  const contentWidth = el.scrollWidth;

  if (width === contentWidth) {
    return;
  }

  const fontSize = parseInt(
    window?.getComputedStyle(el, null).getPropertyValue('font-size'),
    10,
  );

  el.style.fontSize = `${fontSize - 1}px`;

  return fitText(el);
}
